/*
 * premierstreets
 * version 4.5
 * www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { CategorychildrenResponseModel } from './categorychildren-response.model';

export class CategoryResponseModel {
  public categoryId: string;
  public image: string;
  public imagePath: string;
  public isActive: string;
  public metaTagDescription: string;
  public metaTagKeyword: string;
  public metaTagTitle: string;
  public name: string;
  public parentInt: string;
  public type: number;
  public sortOrder: string;
  public categorySlug: string;
  public children: CategorychildrenResponseModel;

  constructor(listResponse: any) {
    this.categoryId = listResponse.categoryId || '';
    this.image = listResponse.image || '';
    this.imagePath = listResponse.imagePath || '';
    this.isActive = listResponse.isActive || '';
    this.metaTagDescription = listResponse.metaTagDescription || '';
    this.metaTagKeyword = listResponse.metaTagKeyword || '';
    this.metaTagTitle = listResponse.metaTagTitle || '';
    this.name = listResponse.name || '';
    this.parentInt = listResponse.parentInt || '';
    this.sortOrder = listResponse.sortOrder || '';
    this.categorySlug = listResponse.categorySlug || '';
    this.type = listResponse.type || 0;
    this.children = listResponse.children
      ? listResponse.children.map(children => {
        return new CategorychildrenResponseModel(children);
      })
      : [];
  }
}
